module.exports = __webpack_public_path__ + "static/media/dashboard.c6e134a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard.svg
// module id = 760
// module chunks = 0